<div class="page full-height gray-font-color font-family bodyBackground">
  <div class="header-navigation-back">
    <mat-icon data-test="back-arrow-icon" (click)="navigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">Shipment Timeline</span>
  </div>
  @if (isContentReady) {
    <div class="margin-bottom-md">
      <div class="section">
        <div class="shipment-meta-container">
          <div class="meta-left">
            <div class="meta-label">Shipment ID</div>
            <div class="shipment-id-row">
              <mat-icon class="meta-icon">local_shipping</mat-icon>
              <div class="shipment-id">{{ shipment.shipmentID || '-' }}</div>
            </div>
            @if (!isConfirmationPending) {
              <div class="shipment-type">{{ this.shipmentType }}</div>
            }
          </div>
          <div class="meta-right">
            <div class="meta-label">Status</div>
            <div class="shipment-status-container">
              <div [ngClass]="[getShipmentStatusClass(), 'status-tag']">
                {{ shipment.status === 'out for delivery' ? 'In Transit' : shipment.status | titlecase }}
              </div>
            </div>
          </div>
        </div>
        <div class="route-container">
          <div class="route-section">
            <div class="route-visual">
              <div class="route-point from-point">
                <mat-icon class="route-icon">radio_button_checked</mat-icon>
              </div>
              <div class="route-line"></div>
              <div class="route-point to-point">
                <mat-icon class="route-icon">location_on</mat-icon>
              </div>
            </div>
            <div class="route-info">
              <div class="route-location">
                <span class="location-label">From</span>
                <div class="location-city">{{ pickupAddress.updatedOrigin || '-' }}</div>
                <div class="location-address">{{ pickupAddress.updatedStreetAddress || '-' }}</div>
                <div class="location-datetime">{{ pickupAddress.updatedPickupDate || '-' }}, {{ pickupAddress.updatedPickupTime || '-' }}</div>
              </div>
              <div class="route-location">
                <span class="location-label">To</span>
                <div class="location-city">{{ deliveryAddress.updatedDestination || '-' }}</div>
                <div class="location-address">{{ deliveryAddress.updatedStreetAddress || '-' }}</div>
                <div class="location-datetime">{{ deliveryAddress.updatedDeliveryDate || '-' }}, {{ deliveryAddress.updatedDeliveryTime || '-' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <mat-divider></mat-divider>
  <div class="detail-panel-body no-scroll">
    <div id="timeline-list" class="margin-top-md margin-left-md shipment-content" data-test="timeline-list">
      @for (status of timelineList; track status) {
        <div class="timeline-section" data-test="timeline-section">
          <div fxFlexFill class="status-header" (click)="toggleDetails(status)" data-test="status-title-row">
            <div class="status-row">
              <div fxFlex="48" class="status-title">
                <h4 [ngClass]="[getStatusClass(status), 'status-tag', 'status-text', 'status-badge']">
                  {{ editDocumentName(status.status) === 'out for delivery' ? 'In Transit' : editDocumentName(status.status) | titlecase }}
                </h4>
              </div>
              <div fxFlex="48" class="date-value status-date">
                <p>{{ status.event[0].date | date: "MMM dd YYYY, HH:mm aaaaa'm'" }}</p>
              </div>
              @if (!status.showDetails) {
                <div fxFlex="4" class="expand-icon">
                  @if (!(status.event.length === 1 && status.event[0].name) || (status.event.length === 1 && status.event[0].type)) {
                    <mat-icon class="icon-color" svgIcon="collapse-down-arrow"></mat-icon>
                  }
                </div>
              }
              @if (status.showDetails) {
                <div fxFlex="4" class="expand-icon">
                  @if (!(status.event.length === 1 && status.event[0].name) || (status.event.length === 1 && status.event[0].type)) {
                    <mat-icon class="icon-color" svgIcon="collapse-up-arrow"></mat-icon>
                  }
                </div>
              }
            </div>
          </div>
          @if (status.showDetails) {
            <div>
              @for (event of status.event; track event) {
                <div class="event-item">
                  <div class="timeline-marker">
                    <div class="outer-circle">
                      <div class="inner-circle"></div>
                    </div>
                    <div class="tracking-line"></div>
                  </div>
                  <div class="event-content">
                    <div class="event-meta">
                      <div  class="date-value">
                        <p>{{ event.date | date: "MMM dd YYYY, HH:mm aaaaa'm'" }}</p>
                      </div>
                      @if (event.name) {
                        <div class="type-value">
                          {{ editDocumentName(event.name) | titlecase }}
                        </div>
                      }
                      @if (event.type) {
                        <div class="type-value">
                          {{ getDisplayName(event.type) | titlecase }}
                        </div>
                      }
                      @if (event.stopType) {
                        <div class="type-value text-align-right">
                          {{ getStopName(event.stopType) | titlecase }}
                        </div>
                      }
                    </div>
                    <div class="event-comment">
                      @if (event.comment) {
                        <div class="comment-value">
                          <strong>Comment: </strong> {{ event.comment }}
                        </div>
                      }
                      <div [fxFlex]="event.showStatus ? '10' : '50'" class="comment-nostatus">
                        @if (event?.comment && event.createdByUserType?.toLowerCase() === 'driver') {
                          <div class="ellipse-container" (click)="openActionSheet(event)" data-test="ellipses-icon">
                            @if (event?.comment) {
                              <mat-icon svgIcon="ellipses"></mat-icon>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="event-image" data-test="timeline-comment">
                      @if (event.documentId) {
                        <div class="image-container">
                          <div fxFlex="89">
                            @if (!event.fileUrl && apiCount) {
                              <div>
                                <ngx-skeleton-loader appearance="line" [theme]="{
                                  height: '100px',
                                  width: '90%',
                                  'background-color': '#c9c9c963'
                                }"></ngx-skeleton-loader>
                              </div>
                            }
                            @if (event.fileUrl) {
                              <img [src]="event.fileUrl" class="shipment-image" data-test="shipment-image" />
                            }
                          </div>
                          <div>
                            @if (event.fileUrl && event.createdByUserType?.toLowerCase() === 'driver') {
                              <div class="ellipse-container" (click)="openActionSheet(event)" data-test="ellipses-icon">
                                <mat-icon svgIcon="ellipses"></mat-icon>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>